import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import TextAdjustLengthIcon from '@atlaskit/icon-lab/core/text-adjust-length';
import { fg } from '@atlaskit/platform-feature-flags';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

import type { EditorPluginAIProvider } from '../../../../../types/types';
import { MakeShorterIcon } from '../../../../icons/prompt/makeShorter';
import type { ConvoAiFeatureId } from '../../../../utils/request/types';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

export const makeShorter: (
	product?: EditorPluginAIProvider['product'],
) => EditorPluginAIConfigItem = (product) => {
	let featureId: ConvoAiFeatureId =
		product !== 'CONFLUENCE' && fg('platform_editor_ai_adf_prompts_in_all_products')
			? 'make_shorter_adf_gpt41mini'
			: 'make_shorter';
	let adfPrompt = product !== 'CONFLUENCE' && fg('platform_editor_ai_adf_prompts_in_all_products');
	if (
		expValEqualsNoExposure('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gpt41mini')
	) {
		featureId = 'make_shorter_adf_gpt41mini';
		adfPrompt = true;
	} else if (
		expValEqualsNoExposure('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gemini25flash')
	) {
		featureId = 'make_shorter_adf_v111';
		adfPrompt = true;
	}

	return {
		key: CONFIG_ITEM_KEYS.MAKE_SHORTER,
		title: aiConfigItemMessages.makeShorterTitle,
		description: aiConfigItemMessages.makeShorterDescription,
		icon: () => <MakeShorterIcon />,
		showInRefineDropdown: true,
		intentSchemaId: 'shorten_intent_schema.json',
		featureId,
		adfPrompt,
		requiresTextualContent: adfPrompt,
		actions: {
			empty: [
				createInsertBelow({ appearance: 'secondary' }),
				createReplace({ appearance: 'primary' }),
			],
			selection: [
				createInsertBelow({ appearance: 'secondary' }),
				createReplace({ appearance: 'primary' }),
			],
		},
		getBackendModel: () => {
			return 'assistance-service';
		},
		get nestingConfig() {
			if (fg('aifc_create_enabled')) {
				return {
					id: 'adjust-length',
					parentTestId: 'adjust-length',
					parentTitle: aiConfigItemMessages.adjustLengthNestingParentTitle,
					shortTitle: aiConfigItemMessages.adjustLengthNestingParentShortTitle,
					icon: () => <TextAdjustLengthIcon label="" spacing="spacious" />,
				};
			}
			return undefined;
		},
	};
};

export const makeShorterWithOptions: (
	product?: EditorPluginAIProvider['product'],
) => EditorPluginAIConfigItemWithOptions = (product) => ({
	config: makeShorter(product),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
